<template>
  <div class="eventType">
    <div class="chart" ref="chart"/>
  </div>
</template>

<script>
import echarts from "echarts";
import api from '../api'

export default {
  name: "EventTypeStatistics",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const {success, returnObj} = await this.$fetch(api.emergency.statEmergencyByType)
      if (success) {
        const listData = []
        let total = 0
        Object.keys(returnObj.dataMap).forEach(key => {
          listData.push({
            name: key,
            value: returnObj.dataMap[key]
          })
          total += returnObj.dataMap[key]
        })
        this.initCharts(listData, total)
      }
    },
    initCharts(listData, total) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const option = {
        color: ['#93BEFF', '#FAC858', '#E23AF5', '#6932F5'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "当年应急事件类型统计",
            type: "pie",
            radius: ["30%", "60%"],
            avoidLabelOverlap: true,
            label: {
              normal: {
                formatter: (params, ticket, callback) => {
                  var percent = 0; //考生占比
                  if (total !== 0) {
                    percent = ((params.value / total) * 100).toFixed(1);
                  }
                  return "{name|" + params.name + "}\n{blue|" + percent + "%}";
                },
                rich: {
                  name: {
                    color: "#EEB9F7",
                    fontSize: 14,
                    // padding: [21, 0],
                    align: "center",
                  },
                  blue: {
                    color: "#FFFFFF",
                    fontSize: 14,
                    align: "center",
                  }
                },
              },
            },
            labelLine: {
              normal: {
                length: 15,
                length2: 15,
                lineStyle: {
                  color: "#F2A5FF",
                },
              },
            },
            data: listData,
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.eventType {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
